import { useCallback } from "react";
import classNames from "classnames";
import { StaticIcon } from "@pickit/pickit-components";
import { COUNTRIES } from "utils/constants";
import { CountrySelectorProps } from "./types";
import { CountryCodeType } from "reducers/types/session";
import { ReactComponent as ActualCountry } from "../../assets/pin.svg";
import "./countrySelector.scss";
import { getFlag } from "utils/utils";

const CountrySelector = ({
  actualCountry = "AR",
  testId,
  changeCountry,
}: CountrySelectorProps) => {
  const onClick = useCallback(
    (country: CountryCodeType) => {
      if (changeCountry) changeCountry(country);
    },
    [changeCountry]
  );

  return (
    <div className="country-selector-container">
      {COUNTRIES.map((country) => (
        <div className="country-flag-container" key={country}>
          <ActualCountry
            width={47}
            height={56}
            className={classNames("country-selected", {
              visible: actualCountry === country,
            })}
          />
          <StaticIcon
            size="large"
            name={getFlag(country)}
            onClick={() => onClick(country)}
            testId={`${testId}-${country}`}
          />
        </div>
      ))}
    </div>
  );
};

export default CountrySelector;
